<template>
	<!-- info card start -->
    <div class="card">
        <div class="card-header">
            <h5 class="card-header-text">Scorecard and Practical Evaluation</h5>
            <a v-bind:href="'/allscorecards/' + $parent.applicant.id" class="btn btn-sm btn-primary waves-effect waves-light f-right">
                View Scorecards
            </a>
        </div>
        <div class="card-block">
        	<div class="row">
                <div class="col-md-8">
                    <div class="card b-l-success business-info services m-b-20">
                        <div class="card-header">
                            <div class="service-header">
                                <h5 class="card-header-text">Interview Scorecard</h5>
                            </div>
                        </div>
                        <div class="card-block">
                            <div class="row">
                                <div class="col-sm-12">
                                	<div class="table-responsive" v-if="$parent.score_cards.length > 0">
                                		<table class="table">
                                            <thead>
                                                <th>Evaluator Name</th>
                                                <th>Score</th>
                                            </thead>
                                			<tbody>
                                				<tr v-for="card in $parent.score_cards">
                                					<td>{{card.first_name + " " + card.last_name}}</td>
                                                    <td>{{ calculateScore(card) }}</td>
                                				</tr>
                                			</tbody>
                                		</table>
                                	</div>
                                    <div v-else>
                                        <h5>This applicant has not been evaluated.</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style type="text/css" soped>
	tr td:nth-child(1){
		font-weight: bold;
	}
</style>
<script type="text/javascript">
	export default{
		name: 'ScorecardSummary',
		data(){
			return{
                
			}
		},
		methods: {

			init: function(){
				
			},

            calculateScore: function(row){
                var evals = row.evaluations
                var score = 0

                this.max_score = (this.max_score < (parseInt(evals.length) * 5)) ? parseInt(evals.length) * 5 : this.max_score

                for(var i=0;i<evals.length;i++){
                    score = score + parseInt(evals[i].score)
                }
                return score
            }
		},
		mounted(){
			this.init()
		}
	}
</script>